module.exports = "/images/telephone.svg";